// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__Oq6Wy","col":"styles_col__5R_U5"};